import PayOrderComplete from "../views/payOrder/payOrderComplete";
import PayOrderExpress from "../views/payOrder/payOrderExpress";
import PaymentOrderList from "../views/payOrder/paymentOrderList";

import ExpressIcon from "../assets/icons/express.svg";
import ExpressIconHover from "../assets/icons/expressHover.svg";
import CompleteIcon from "../assets/icons/complete.svg";
import CompleteIconHover from "../assets/icons/completeHover.svg";
import ListIcon from "../assets/icons/plans.svg";
import ListHoverIcon from "../assets/icons/plans-hover.svg";

const routesPayOrder = [
    {
        id: "cm4a3",
        path: "/list",
        name: "Boletos Gerados",
        icon: ListIcon,
        iconHover: ListHoverIcon,
        layout: "/pay-order",
        component: PaymentOrderList,
        redirect: false,
    },

    {
        id: "cm4a1",
        path: "/express",
        name: "Expresso",
        icon: ExpressIcon,
        iconHover: ExpressIconHover,
        layout: "/pay-order",
        component: PayOrderExpress,
        redirect: false,
    },
    
    {
        id: "cm4a2",
        path: "/complete",
        name: "Completo",
        icon: CompleteIcon,
        iconHover: CompleteIconHover,
        layout: "/pay-order",
        component: PayOrderComplete,
        redirect: false,
    },
]

export default routesPayOrder;